import { defineComponent as c, openBlock as i, createElementBlock as l, normalizeClass as r, normalizeStyle as a, unref as p } from "vue";
const f = ["title"], u = /* @__PURE__ */ c({
  __name: "FlagIcon",
  props: {
    code: {},
    size: {},
    square: { type: Boolean },
    circle: { type: Boolean },
    title: { type: [String, Function] }
  },
  setup(n) {
    const o = n, t = new Intl.DisplayNames(["en"], { type: "region" }).of(o.code.toUpperCase()) || "Unknown", s = o.title instanceof Function ? o.title(t) : o.title || t;
    return (e, m) => (i(), l("span", {
      class: r(["fi", [e.square || e.circle ? "fis" : "", `fi-${e.code.toLowerCase()}`, e.circle ? "round" : ""]]),
      style: a(e.size ? `font-size:${e.size}px` : void 0),
      title: p(s)
    }, null, 14, f));
  }
}), d = (n, o) => {
  const t = n.__vccOpts || n;
  for (const [s, e] of o)
    t[s] = e;
  return t;
}, _ = /* @__PURE__ */ d(u, [["__scopeId", "data-v-bbfbeec4"]]);
export {
  _ as default
};
